var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ParentCommunicationAdviserRecords.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-36a88403\",\"hasScoped\":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ParentCommunicationAdviserRecords.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/user/ParentCommunicationAdviserRecords.vue
// module id = 1558
// module chunks = 8